import { defineStore } from "pinia";
import { computed, readonly, ref } from "vue";

/**
 * Which mandate the editor modal is open on, for every page that can open one.
 *
 * A mandate is reached from the dashboard's forward sales card, the deal page, the volume picker and
 * `/admin/forwards`; each of those pages renders one `MandateEditorModalHost` driven by this store, and
 * anything on them that links to a mandate calls `open`, rather than every link threading an event back
 * up to the page. The host
 * tells its page when a session wrote something.
 */
export const useMandateEditorLauncher = defineStore(
  "forwards2MandateEditorLauncher",
  () => {
    /** The open mandate's id, `null` for a new mandate, `undefined` while the editor is closed. */
    const mandateId = ref<number | null | undefined>(undefined);

    const isOpen = computed(() => mandateId.value !== undefined);

    const open = (id: number | null) => {
      mandateId.value = id;
    };

    const close = () => {
      mandateId.value = undefined;
    };

    return {
      mandateId: readonly(mandateId),
      isOpen,
      open,
      close,
    };
  }
);
